// Note: @shoelace-style/shoelace/dist/themes/light.css is imported from
// styles/main.css via @import. Importing it here too would inject a
// SECOND copy at runtime, after our brand-palette overrides in main.css,
// which would re-apply Shoelace's default sky-blue primary palette and
// undo the override.
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/badge/badge.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import '@shoelace-style/shoelace/dist/components/tab/tab.js';
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js';
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js';
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js';

import { api, type AuthUser } from './api/client.js';
import { renderLoginPage } from './pages/login.js';
import { renderComponentsListPage } from './pages/components-list.js';
import { renderChangePasswordPage } from './pages/change-password.js';

// Use the official CDN for Shoelace assets (icons, etc.) so we don't need to
// copy them into the Vite build output. Switch to a self-hosted path if/when
// offline operation becomes a requirement.
setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.18.0/cdn/');

const root = document.getElementById('app');
if (!root) {
  throw new Error('Missing #app root element');
}

async function bootstrap(target: HTMLElement) {
  let user: AuthUser | null = null;
  try {
    const me = await api.me();
    user = me.user;
  } catch {
    user = null;
  }

  if (!user) {
    renderLoginPage(target, () => bootstrap(target));
    return;
  }

  // Hard gate: every freshly invited user lands here. The backend
  // refuses every /api/* call other than logout / me / change-password
  // while this flag is set, so we can't render the components list
  // even if we wanted to. Re-bootstraps after the flip via api.me().
  if (user.mustChangePassword) {
    renderChangePasswordPage(
      target,
      user,
      () => bootstrap(target),
      () => bootstrap(target),
    );
    return;
  }

  renderComponentsListPage(target, user, () => bootstrap(target));
}

void bootstrap(root);
